import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import Loader from "../../Loader";
import { t } from "i18next";
export var InfiniteScroll = function InfiniteScroll(_ref) {
  var hasNextPage = _ref.hasNextPage,
    onLoadMore = _ref.onLoadMore,
    children = _ref.children,
    shouldShowLoader = _ref.shouldShowLoader;
  var sentinelRef = useRef(null);
  useEffect(function () {
    var el = sentinelRef.current;
    if (!el) return;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];
      if (entry.isIntersecting && hasNextPage) {
        onLoadMore();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return function () {
      return observer.disconnect();
    };
  }, [hasNextPage]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement("div", {
    ref: sentinelRef,
    className: "flex items-center justify-center pb-5"
  }, shouldShowLoader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loader, {
    size: "small"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 text-teal-500 dark:text-gray-500 text-sm"
  }, t("label.loading")))));
};